var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarTaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.75,
    stroke: "#BEBBB3",
    strokeWidth: 1.5,
    className: "svg-secondary"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38775 8.77957C5.09486 8.48667 4.61999 8.48667 4.32709 8.77957C4.0342 9.07246 4.0342 9.54733 4.32709 9.84023L5.38775 8.77957ZM12.2687 7.00689C12.5616 6.714 12.5616 6.23913 12.2687 5.94623C11.9758 5.65334 11.5009 5.65334 11.208 5.94623L12.2687 7.00689ZM6.73981 11.1923L6.20948 11.7226L6.73981 11.1923ZM7.02265 11.1923L7.55298 11.7226L7.02265 11.1923ZM4.32709 9.84023L6.20948 11.7226L7.27014 10.662L5.38775 8.77957L4.32709 9.84023ZM7.55298 11.7226L12.2687 7.00689L11.208 5.94623L6.49232 10.662L7.55298 11.7226ZM6.20948 11.7226C6.58048 12.0936 7.18198 12.0936 7.55298 11.7226L6.49232 10.662C6.70711 10.4472 7.05535 10.4472 7.27014 10.662L6.20948 11.7226Z",
    fill: "#BEBBB3",
    className: "svg-primary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTaskIcon);
export default __webpack_public_path__ + "static/media/SidebarTaskIcon.e4a4c475.svg";
export { ForwardRef as ReactComponent };